import styled from 'styled-components';
import {
  BLACK,
  WHITE,
  SALON_CONSULTATION_HEADER_HEIGHT_SP,
  SALON_CONSULTATION_HEADER_HEIGHT_PC,
} from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Container = styled.div`
  margin: 64px auto 0;
  width: 100%;
  height: calc(100vh - ${SALON_CONSULTATION_HEADER_HEIGHT_SP});
  // margin-top: ${SALON_CONSULTATION_HEADER_HEIGHT_SP};

  ${media.tabletP`
    height: calc(100vh - ${SALON_CONSULTATION_HEADER_HEIGHT_PC});
    margin-top: ${SALON_CONSULTATION_HEADER_HEIGHT_PC};
  `};
`;

export const HeroImage = styled.div`
  height: 300px;
  background: #eee;
  position: relative;

  ${media.tabletP`
    height: 360px;
  `};
`;

export const SalonConsultationText = styled.div`
  font-size: 38px;
  font-weight: 500;
  color: ${BLACK};
  position: absolute;
  left: 40px;
  top: 26%;

  ${media.tabletP`
    left: 70px;
    top: 26%;
  `};
`;

export const News = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 20px 40px;

  ${media.tabletP`
    padding: 30px 70px;
  `};
`;

export const NewsTitle = styled.div`
  margin-bottom: 10px;
`;

export const NewsBody = styled.div`
  p {
    font-size: 14px;
    margin-bottom: 0;
  }
`;

export const MenuContents = styled.div`
  width: 100%;
  background-color: #333;
  padding: 30px;

  ${media.tabletP`
    padding: 40px;
  `};
`;

export const MenuContentsInner = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const MenuCategory = styled.div`
  background-color: #fff;
  margin-bottom: 20px;
  padding: 50px 30px 10px;

  ${media.tabletP`
    padding: 50px 50px 10px;
  `};
`;

export const MenuCategoryTitle = styled.div`
  margin-bottom: 30px;
  font-size: 26px;

  ${media.tabletP`
    margin-bottom: 40px;
  `};
`;

export const MenuCategoryList = styled.div`
  ${media.tabletP`
    display: flex;
    flex-wrap: wrap;
  `};
`;

export const MenuCategoryListItem = styled.div`
  margin-bottom: 30px;

  ${media.tabletP`
    margin-bottom: 40px;
    width: calc(50% - 10px);
    &:nth-child(odd) {
      margin-right: 20px;
    }
  `};
`;

export const MenuCategoryListItemTitle = styled.div`
  margin-bottom: 10px;
`;

export const MenuCategoryListItemLink = styled.a`
  background-color: ${BLACK};
  border: none;
  color: ${WHITE};
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 60px;
  width: 100%;
  outline: none;
  text-transform: uppercase;
  padding: 0;
  align-items: center;
  display: flex;
  justify-content: center;

  &:hover {
    color: ${WHITE};
  }
`;

export const CustomerInfo = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;

  ${media.tabletP`
    justify-content: flex-end;
    margin-top: 0;
  `};
`;

export const Image = styled.img`
  margin: 0 auto;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const ContentContainer = styled.div`
  flex: 1;
  min-width: 375px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const Content = styled.div``;

export const DiagnosisButtonWrapper = styled.div`
  width: calc(100% - 40px);
  height: 60px;
  margin: 3em 20px 0;

  ${media.tabletP`
    width: 285px;
    margin: 3em auto 0;
  `};
`;

export const DiagnosisButton = styled.button`
  background-color: ${BLACK};
  border: none;
  color: ${WHITE};
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 60px;
  width: 100%;
  outline: none;
  text-transform: uppercase;
  padding: 0;

  ${media.tabletP`
    align-items: center;
    display: flex;
    justify-content: center;
  `};
`;

export const HairColorButtonWrapper = styled.div`
  width: calc(100% - 40px);
  height: 60px;
  margin: 2em 20px 0;

  ${media.tabletP`
    width: 285px;
    margin: 2em auto 0;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/HomePage/HomePage.style.js